'use client';
import { useModal } from 'react-hooks-use-modal';
import { ROOT_LAYOUT_DOM_NODE_ID } from '@/config/appSettings';

import { Row, Stack } from '@/ui/primatives';
import * as Icon from '@/ui/Icon';
import Button from '@/ui/Button';
import OxenModal from '@/ui/Modal';

import useDataframeContext from '../../DataframeContext';

const DownloadResults: React.FC<{}> = ({}) => {
  const { resultsDownloadUrl, searchParams } = useDataframeContext();
  const isQuery = !!searchParams.query_id;

  const [Modal, open, close, isOpen] = useModal(ROOT_LAYOUT_DOM_NODE_ID, { preventScroll: true });

  const csvLink = resultsDownloadUrl('csv');
  const jsonLink = resultsDownloadUrl('json');
  const parquetLink = resultsDownloadUrl('parquet');
  const tsvLink = resultsDownloadUrl('tsv');
  const jsonlLink = resultsDownloadUrl('jsonl');
  const ndjsonLink = resultsDownloadUrl('ndjson');

  return (
    <>
      <Button.Basic tiny onClick={() => (isOpen ? close() : open())}>
        <Icon.Download size="12" /> Download Results
      </Button.Basic>

      <OxenModal Modal={Modal} isOpen={isOpen} close={close}>
        <OxenModal.Header>
          <Row gap={10} alignItems="center">
            <Icon.Download size="16" style={{ strokeWidth: 1.5 }} />
            <b style={{ fontSize: 16 }}>Download {isQuery ? 'query results' : 'this dataset'}</b>
          </Row>
        </OxenModal.Header>
        <OxenModal.Body>
          <Stack gap={20}>
            <div>Oxen supports export in the following formats.</div>
            <Row gap={5}>
              <Button.Basic tiny href={csvLink} onClick={close} download>
                CSV
              </Button.Basic>
              <Button.Basic tiny href={jsonLink} onClick={close} download>
                JSON
              </Button.Basic>
              <Button.Basic tiny href={parquetLink} onClick={close} download>
                Parquet
              </Button.Basic>
              <Button.Basic tiny href={tsvLink} onClick={close} download>
                TSV
              </Button.Basic>
              <Button.Basic tiny href={jsonlLink} onClick={close} download>
                JSONL
              </Button.Basic>
              <Button.Basic tiny href={ndjsonLink} onClick={close} download>
                NDJSON
              </Button.Basic>
            </Row>
          </Stack>
        </OxenModal.Body>
      </OxenModal>
      {/* {isOpen && (
        <Modal>
          <Styled.Modal>
            <Styled.ModalClose>
              <Icon.X size="24px" onClick={close} />
            </Styled.ModalClose>
            <div>Download {isQuery ? 'the results of this query' : 'this dataset'} as</div>
            <Row gap={5}>
              <Button.Basic tiny href={csvLink} download>
                CSV
              </Button.Basic>
              <Button.Basic tiny href={jsonLink} download>
                JSON
              </Button.Basic>
              <Button.Basic tiny href={parquetLink} download>
                Parquet
              </Button.Basic>
              <Button.Basic tiny href={tsvLink} download>
                TSV
              </Button.Basic>
              <Button.Basic tiny href={jsonlLink} download>
                JSONL
              </Button.Basic>
              <Button.Basic tiny href={ndjsonLink} download>
                NDJSON
              </Button.Basic>
            </Row>
          </Styled.Modal>
        </Modal>
      )} */}
    </>
  );
};

export default DownloadResults;
